const handleLoadStart = () => {
    var _a;
    const loadingMessage = "<div class='loading-message'><span>レッスン予定を取得しています...</span></div>";
    (_a = document.querySelector("form#reservation-form p.place")) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML("afterend", loadingMessage);
};
export default handleLoadStart;
